export const GENERAL_SLIDE_PARSE = () => ['data.button', 'data.title', 'data.perex']
export const POST_SLIDE_PARSE = () => ['data.button', 'data.title', 'data.perex']
export const EDITOR_PARSE = () => ['data.value']
export const HEADING_PARSE = () => ['data.value']
